import { render } from "./CodeBlock.vue?vue&type=template&id=ae2d421e&scoped=true&lang=pug"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=ae2d421e&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-ae2d421e"

export default script